module.exports = __webpack_public_path__ + "media/images/global/icons/church-ed2c9e8958b473c8cc6d58779e0721d8.svg";